const c_loadingClass = 'c_loop-loading';
const c_active_vendorClass= 'active-vendor';
const c_showHiddenClass ='c_show-hidden';
const c_hiddenLoadedClass ='c_hidden-loaded';


$(document).ready(function(){
  $(document).on("click",".c_loop-all_tag",function(e){
    e.preventDefault();
    if(!$(this).hasClass(c_active_vendorClass)){
      $(this).addClass(c_active_vendorClass).siblings().removeClass(c_active_vendorClass);
      var url = $(this).data('tag');
      var loop = $(this).data('loop');
      $(loop).removeClass(c_hiddenLoadedClass);
      $(loop).removeClass(c_showHiddenClass);
      $(loop).addClass(c_loadingClass);
      grabProducts(url+'?view=avail',loop,vendorCallback);

    }
    return false;
  })
  $(document).on("click",".c_loop-show-sold-out",function(e){
    e.preventDefault();
    var loop = $(this).data('loop');
    var collection = $(loop).closest('.c_loop');
    //first click - fetch soldout products
    if(!$(loop).hasClass(c_hiddenLoadedClass) ){	
      $(loop).addClass(c_showHiddenClass);
      $(loop).addClass(c_hiddenLoadedClass);
      $(loop).addClass(c_loadingClass);
      var url = collection.find('.c_loop-vendor.active-vendor').attr('href');
        
      
      console.log(url);
      grabProducts(url+'?view=unavail',loop,soldoutCallback);
    }
    //later switch between showing and hiding the products / switching 'sold-out' card text
    else if(!$(loop).hasClass(c_showHiddenClass)){
    	$(loop).addClass(c_showHiddenClass);
    }
    else {
    	$(loop).removeClass(c_showHiddenClass);
    }
    return false;
  })
  
 
})

$(document).ready(function(){
	$('#sort_by').val('manual');
})

//Dynamic sorting
Shopify.queryParams = {};
if (location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}
jQuery('#sort-by')
.val('')
     .bind('change', function() {

  
  var sortVal = $(this).val();
  Shopify.queryParams.sort_by = sortVal;
  $('.c_loop').each(function(){
    var container = $(this);
    var url = container.find('.active-vendor').attr('href');
    if(url == '#'){
      var url = container.find('.active-vendor').data('tag');
    }
    url += '?sort_by='+ sortVal+ '&view=avail';
    var collectionHandle = $(container).data('handle');
    var loop = '#c_product-loop-'+collectionHandle;
    $(loop).addClass(c_loadingClass);
    grabProducts(url,loop,sortCallback);
    //location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
  })
});


function sortCallback(html,loop){
  var newLoop = $(html).find(loop);
  $(loop).html(newLoop.html());
  console.log(loop);
  console.log($(html))
  console.log(newLoop.html());
  setTimeout(function(){
    $(loop).removeClass(c_loadingClass);
    $('.options select').trigger('change');
  },10)
  //Added timeout so that the loading class has time to active and recalculate prices / weights
}

function vendorCallback(html,loop){
  var newLoop = $(html).find(loop);
  var handle = $(newLoop).data('handle');
  var availElem = $("#c_"+handle).find(".c_avail");
  var newAvail = $(newLoop).data('avail');
  $(availElem).text(newAvail);
  console.log($(newLoop));
  $(loop).html(newLoop.html());
  setTimeout(function(){
    $(loop).removeClass(c_loadingClass);
    $('.options select').trigger('change');
  },10)
  //Added timeout so that the loading class has time to active and recalculate prices / weights
}

function soldoutCallback(html,loop){
  console.log(Shopify.queryParams.sort_by);
  var soldoutProducts = $(html).find(loop);
  $(soldoutProducts.html()).insertAfter($(loop).find('.c_loop-sold-card'));
  setTimeout(function(){
    $(loop).removeClass(c_loadingClass);
    $('.options select').trigger('change');
  },10)
}

function grabProducts(url,loop,callback){
 
  if(Shopify.queryParams.sort_by){
  	url +='&sort_by='+Shopify.queryParams.sort_by;
  }
  
  setTimeout(function(){
	$.ajax({ 
      type: 'GET',
      url: url,
      async: false, 
      success: function(html){ 
        callback(html,loop);
      } 
    });
  },10)
  //Added timeout so that the loading class has time to active and recalculate prices / weights
}


$(document).on("focusin",".c_quantity",function(){
	var currentVal = $(this).val();
  $(this).on('keydown',function(e){
  	$(this).val('');
    $(this).off('keydown');
  })

})